<template>
  <span class="sleep-radio__icon d-block mx-auto">
    <img :src="this.iconPath" alt="" />
  </span>
</template>

<script>
export default {
  name: "Icon",
  props: {
    iconPath: {
      type: String,
      default: "",
    },
  },
};
</script>
